<template>
  <div id="app">
    <div id="top">
      <span class="iconfont icon-huidingbu"></span>
    </div>
    <Header></Header>
   <keep-alive>
       <router-view v-if="$route.meta.keepAlive"></router-view>
   </keep-alive>
   <router-view v-if="!$route.meta.keepAlive"></router-view>
    <Footer />
  </div>
</template>
<script>
import Header from './components/header';
import Footer from './components/footer';
export default {
  data(){
    return{
      header:1
    }
  },
  components: {
    Header,
    Footer,
  },
  created(){
    // new DevicePixelRatio().init()
  },
  mounted() { 
    var that = this
     $(function() {
        $(window).scroll(function(){
                if ($(window).scrollTop()>500){
                    $("#top").fadeIn(1000);
                }else {
                    $("#top").fadeOut(1000);
                }
            });
            $('#top').mouseover(function() {
                $('#top').attr('title','点击返回顶部')
                $('#top')[0].style.cursor='pointer'
            })
            $("#top").click(function(){
                $('body,html').animate({scrollTop:0},1000);
        if ($('html').scrollTop()) {
                $('html').animate({ scrollTop: 0 }, 800);
                return false;
            }
            $('body').animate({ scrollTop: 0 }, 800);
                 return false;            
           });    
      })
      // this.detectZoom()
      // console.log(this.detectZoom())
       this.$nextTick(()=>{
              window.addEventListener('resize', () => { //监听浏览器窗口大小改变
                       //浏览器变化执行动作
                    var num = this.detectZoom()
                    that.header = num
                    // console.log(that.header)
              });
        })
  },
  methods: {
  detectZoom (){ 
  var ratio = 0,
    screen = window.screen,
    ua = navigator.userAgent.toLowerCase();
   if (window.devicePixelRatio !== undefined) {
      ratio = window.devicePixelRatio;
  }
  else if (ua.indexOf('msie')) {  
    if (screen.deviceXDPI && screen.logicalXDPI) {
      ratio = screen.deviceXDPI / screen.logicalXDPI;
    }
  }
  else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
    ratio = window.outerWidth / window.innerWidth;
  }
   
   if (ratio){
    ratio = Math.round(ratio * 100);
  }
   return ratio/100;
}


  },
}
</script>

<style lang='scss' scoped>
#app{
  background: #f2f2f2
}
#top {
  width: 4rem;
  height: 4rem;
  position: fixed;
  bottom: 80px;
  right: 120px;
  z-index: 999;
  background-color: #0e6eff;
  text-align: center;
  line-height: 4rem;
  border-radius: 50%;
  display: none;
  span {
    color: white;
    font-size: 30px;
  }
  .layout {
      width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
}
</style>



// WEBPACK FOOTER //
// src/App.vue